<template>
  <div class="expandable-content-wrapper">
    <v-data-table
      v-if="showContent"
      :headers="headers"
      :items="item.devices"
      hide-default-footer
      :items-per-page="-1"
      :mobile-breakpoint="0"
    />
    <p v-if="showMessage">{{ $t('manageSubscriptions.sharedSubscriptionDevicesMessage') }}</p>
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue'
import { useDisplay } from 'vuetify'
import type { DataTableHeader } from 'vuetify'
import { subscriptionTiers } from '@/store/subscriptions/utils'
import type { SubscriptionTableRow } from '@/views/manage-subscriptions.vue'

interface ExpandableDevice {
  name: string
  type: string
  serial: string
}

export default defineComponent({
  name: 'ExpandableContent',
  setup() {
    const { smAndDown } = useDisplay()
    return { smAndDown }
  },
  props: {
    item: {
      type: [Object, null] as PropType<SubscriptionTableRow | null>,
      default: null
    }
  },
  computed: {
    headers(): DataTableHeader<ExpandableDevice>[] {
      return [
        {
          title: this.$t('manageSubscriptions.expandedTable.deviceName'),
          key: 'name',
          ...(!this.isMobile && { minWidth: 170 })
        },
        {
          title: this.$t('manageSubscriptions.expandedTable.deviceType'),
          key: 'type',
          ...(!this.isMobile && { minWidth: 150 })
        },
        {
          title: this.$t('manageSubscriptions.expandedTable.deviceSerial'),
          key: 'serial',
          ...(!this.isMobile && { minWidth: 150 })
        }
      ]
    },
    isMobile(): boolean {
      return this.smAndDown
    },
    showMessage(): boolean {
      if (this.item?.subscriptionId === subscriptionTiers.TSILINK_STANDARD) {
        return false
      }
      return !!(
        this.item?.deviceQuantityUsed &&
        this.item.devices &&
        this.item.deviceQuantityUsed !== this.item.devices.length
      )
    },
    showContent(): boolean {
      return !!this.item?.devices?.length
    }
  }
})
</script>

<style lang="scss" scoped>
.expandable-content-wrapper {
  margin-left: 3.5rem;

  :deep(.v-table) {
    margin: 16px 0;

    > .v-table__wrapper > table {
      background-color: var(--tsi-color--dark-8);
      max-width: 40rem;

      th,
      td {
        word-break: break-word;
      }
    }
  }

  .mobile & {
    margin-left: 0;

    :deep(.v-table) {
      background-color: inherit;

      tr {
        th,
        td {
          padding: 8px !important;
          font-size: 0.75rem !important;
          height: auto !important;
          word-break: break-word;
          width: 32%;
        }

        th:nth-child(1),
        td:nth-child(1) {
          width: 35%;
        }
      }
    }
  }
}

p {
  font-style: italic;
  margin: 10px 0;

  .expandable-content-column.mobile & {
    font-size: 0.875rem;
  }
}
</style>
